/**
 * Omani rial.
 */
export var OMR = {
  code: 'OMR',
  base: 10,
  exponent: 3
};